import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ComponentsWithConfigsList,
  DeployedActorObject
} from '../../../../configuration/componentsWithConfigs.datamodel';
import { FilterItemList } from '../filterlist/filterItemList.datamodel';
import { LSSEntityObject } from '../../lssEntity.datamodel';
import { ConfigurationService } from '../../../../configuration/store/configuration.service';
import { EditConfigurationFn, EditConfigurationModel } from './edit-configuration.model';
import {
  DEPLOYMENT_LEVEL_CATEGORIES,
  DeploymentLevel,
  DeploymentLevelCategory
} from '../../../../deployments/store/deployment.datamodel';
import { MASSIVE_CONFIG_CHUNK } from '../../../../deployments/deployment.constants';
import { AccordionModule } from '../accordion/accordion.module';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ama-ng-app-store-edit-configuration',
  templateUrl: './editConfiguration.component.html',
  imports: [
    AccordionModule,
    PipesModule
  ],
  standalone: true
})
export class EditConfigurationComponent {
  @Input() cmpsWithConfigs!: ComponentsWithConfigsList;
  @Input() entitySelected!: LSSEntityObject;
  @Input() redefinedConfigSuccess!: string;
  @Input() selectedConfigurations: any;
  @Input() selectedEntities!: Array<FilterItemList>;
  @Input() deployedActors!: Array<DeployedActorObject>;
  @Input() editConfiguration = false;
  @Input() deploymentCategory: DeploymentLevelCategory = DEPLOYMENT_LEVEL_CATEGORIES.OFFICE;
  @Input() appId!: string;
  @Input() orgId!: string;
  @Input() displayDynamicForm!: boolean;

  constructor(
    public readonly activeModal: NgbActiveModal,
    public readonly configService: ConfigurationService,
  ) {
  }

  save() {
    const deployedConfigurations = EditConfigurationFn.transformDeployedConfigurations(this.deployedActors);
    const accesses = EditConfigurationFn
      .buildAccessesFromConfigurations(
        this.selectedConfigurations,
        this.selectedEntities,
        deployedConfigurations,
        this.deploymentCategory?.level ?? DeploymentLevel.OFFICE);
    if (accesses?.length <= MASSIVE_CONFIG_CHUNK) {
      this.configService.updateScriptConfigurationAction(
        this.appId,
        this.orgId,
        accesses,
        this.getSelectedConfigurations());
    } else {
      const massiveList = this.computeMassiveAccessesList(accesses);
      this.configService.updateMassiveScriptConfigurationAction(
        this.appId,
        this.orgId,
        massiveList,
        this.getSelectedConfigurations(),
        accesses?.length,
        0);
    }
    this.activeModal.close('CONFIRM');
  }

  private getSelectedConfigurations() {
    return this.cmpsWithConfigs.components.reduce((components, component) => {
      const name = component.configurations.find(config => config.guid === this.selectedConfigurations[component.component.id])?.name;
      return {
        ...components,
        guids: {...components.guids, [component.component.id]: this.selectedConfigurations[component.component.id]},
        names: {...components.names, [this.selectedConfigurations[component.component.id]]: name}
      };
    }, {guids: {}, names: {}});
  }

  private computeMassiveAccessesList(accesses: EditConfigurationModel[]) {
    const accessesList: EditConfigurationModel[][] = [];
    for (let index = 0; index < accesses?.length; index += MASSIVE_CONFIG_CHUNK) {
      accessesList.push(accesses?.slice(index, index + MASSIVE_CONFIG_CHUNK));
    }
    return accessesList;
  }
}
